// @flow
import * as React from "react"
import urls from "data/router/urls"
import ReservationTile from "./ReservationTile"
import type { Reservation } from "data/reservations/types"
import EmptyState from "./EmptyState"
import { ReservationItemLink } from "./styled"

type Props = {|
  reservations: Reservation[],
|}

const ReservationsList = ({ reservations }: Props) => {
  if (reservations.length === 0) return <EmptyState />

  return (
    <React.Fragment>
      {reservations.map(r => (
        <ReservationItemLink key={r.id} to={urls.reservation(r.id)}>
          <ReservationTile reservation={r} />
        </ReservationItemLink>
      ))}
    </React.Fragment>
  )
}

export default ReservationsList



// WEBPACK FOOTER //
// ./src/components/ReservationList/index.js